import { createStreamEpic } from '../../../signalr/createStreamEpic'
import { fetchAggressAttemptDefinition } from './definition'

export default createStreamEpic(
  'aggressAttempts.fetch',
  fetchAggressAttemptDefinition
)
